export default __webpack_public_path__ + "static/media/katherine-morales.ca3f2e2f.jpg";